import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './Css/MySubscription.css';
import './Css/MySubscription-responsive.css';

import { Ripple } from "primereact/ripple";
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";

import NoDataCreated from "../../Components/NoDataCreated";
import ErrorPage from "../../Components/ErrorPage";
import DocumentViewModal from "../../Components/DocumentViewModal";
import PageLoader from "../../Components/PageLoader";
import { goToTop } from "../../Components/goToTop";
import { getAppCurrencyType } from "../../Utils/Common";

import { SubscriptionPlan } from "../../Controllers/Types/SiteMenuModel/MySubscription/SubscriptionPlan";
import { SubscriptionHistory } from "../../Controllers/Types/SiteMenuModel/MySubscription/SubscriptionHistory";
import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { getMySubscription, getPaymentHistory } from "../../Controllers/Thunks/SiteMenuThunks";

const MySubscription: React.FC = () => {
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const currencySymbol = getAppCurrencyType();

    const loadingPage = useAppSelector((state) => state?.mySubscriptionList?.loader);
    const error = useAppSelector((state) => state?.mySubscriptionList?.errorDisplay);

    const [subscriptionViewState, setSubscriptionViewState] = useState<'My plan' | 'History'>('My plan');
    const [showSubscriptionHistoryViewModal, setShowSubscriptionHistoryViewModal] = useState<boolean>(false);
    const [showSubscriptionPlanViewModal, setShowSubscriptionPlanViewModal] = useState<boolean>(false);
    const [invoiceURL, setInvoiceURL] = useState<string | null>(null);
    const [showInvoiceViewModal, setShowInvoiceViewModal] = useState(false);

    const [subscriptionPlanData, setSubscriptionPlanData] = useState<SubscriptionPlan[]>([]);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState<SubscriptionPlan | null>(null);
    const [subscriptionHistoryData, setSubscriptionHistoryData] = useState<SubscriptionHistory[]>([]);
    const [selectedSubscriptionHistory, setSelectedSubscriptionHistory] = useState<SubscriptionHistory | null>(null);


    //  data base fetch informations
    // for the resons
    const dispatch = useAppDispatch();

    // for fetching data fro api tigger with state object actions
    useEffect(() => {
        dispatch(getMySubscription());
        dispatch(getPaymentHistory());
    }, [dispatch]);

    // this is get data from state list and set projectlist
    const subscriptionList = useAppSelector((state) => state.mySubscriptionList.mySubscriptionList);

    const paymentHistory = useAppSelector((state) => state.paymentHistory.paymentHistory);

    const loadingPaymentHistory = useAppSelector((state) => state?.paymentHistory?.loader);

    // set value if chnages of database fetch.

    const handleSwitchSubscriptionViewState = (state: 'My plan' | 'History') => {
        setSubscriptionViewState(state);
        goToTop();
    }

    useEffect(() => {
        setSubscriptionPlanData(subscriptionList)
    }, [subscriptionList])

    useEffect(() => {
        setSubscriptionHistoryData(paymentHistory);
    }, [paymentHistory])

    /* Subscription plan */
    const handleCloseSubscriptionPlanViewModal = () => {
        setShowSubscriptionPlanViewModal(false);
        setSelectedSubscriptionPlan(null);
    }

    const handleViewSubscriptionPlan = (data: SubscriptionPlan) => {
        if (data) {
            setShowSubscriptionPlanViewModal(true);
            setSelectedSubscriptionPlan(data);
        } else {
            setSelectedSubscriptionPlan(null);
        }
    }

    const subscriptionPlanModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Projects with {selectedSubscriptionPlan?.plan_name}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseSubscriptionPlanViewModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    )
    /*  */

    /* Subscription history */
    const statusBodyTemplate = (rowData: SubscriptionHistory) => {
        const status = rowData.status;
        let labelColor = '';
        let icon = '';
        let color = '';

        if (status === 'Active') {
            labelColor = '#B9F6CA';
            icon = 'bi bi-check-circle-fill';
            color = '#05ac05';
        } else if (status === 'Deactive') {
            labelColor = '#e7e7e7';
            icon = 'bi bi-exclamation-circle-fill';
            color = '#7f7f7f';
        }

        return (
            <div className="flex_center">
                <span className="priority_label" style={{ backgroundColor: labelColor, color: color }}>
                    <i className={`${icon} me-1`} style={{ color: color }}></i>
                    {status === 'Active' ? 'Active' : 'Inactive'}
                </span>
            </div>
        )
    }

    const handleCloseSubscriptionHistoryViewModal = () => {
        setShowSubscriptionHistoryViewModal(false);
        setSelectedSubscriptionHistory(null);
    }

    const handleViewSubscriptionHistory = (data: SubscriptionHistory) => {
        if (data) {
            setShowSubscriptionHistoryViewModal(true);
            setSelectedSubscriptionHistory(data);
        } else {
            setSelectedSubscriptionHistory(null);
        }
    }

    const tableActionBody = (rowData: SubscriptionHistory) => {
        const data = rowData;
        return (
            <React.Fragment>
                <Tooltip
                    key={`view_${data?.id}`}
                    id={`view_${data?.id}`}
                    target={`.view_${data?.id}`}
                />

                <div className="tabel_btn_area custom mt-1 mb-1">
                    <button
                        className={`data_action_btn view_${data?.id} with_bg primary_table_btn p-ripple`}
                        onClick={() => handleViewSubscriptionHistory(data)}
                        data-pr-tooltip={`View more details`}
                        data-pr-position="top"
                    >
                        <i className="bi bi-eye-fill"></i>
                        <Ripple />
                    </button>
                </div>
            </React.Fragment>
        )
    }

    const handleViewInvoice = (document: string) => {
        setInvoiceURL(document);
        setShowInvoiceViewModal(true);
    }

    const handleCloseInvoiceViewModal = () => {
        setShowInvoiceViewModal(false);
    };

    const invoiceViewBody = (rowData: SubscriptionHistory) => {
        return (
            <span className="d-flex justify-content-center">
                {rowData.invoice !== null ? (
                    <button className="doc_view_btn p-ripple"
                        onClick={() => handleViewInvoice(rowData.invoice ?? '')}>
                        <Ripple />
                        <i className="bi bi-file-earmark-pdf"></i>
                    </button>
                ) : (
                    <span className="text-secondary text-center">---</span>
                )}
            </span>
        )
    }

    const subscriptionHistoryModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Subscription details
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseSubscriptionHistoryViewModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    )
    /*  */


    /* **************************** Common functions ***************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* *************************************************************************** */
    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingPage ? (
                    <PageLoader />
                ) : error ? (
                    <ErrorPage errorMessage={error} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="d-flex align-items-center justify-content-between">
                            <h4 className="main_heading">My subscriptions</h4>
                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-sm-3 mt-3">
                            <div className="contact_tabs">
                                <div className="contact_tab_item">
                                    <button type="button"
                                        className={`contact_tab_btn fixed_width ${subscriptionViewState === 'My plan' ? 'active' : ''} p-ripple`}
                                        onClick={() => (handleSwitchSubscriptionViewState('My plan'))}>
                                        My plan
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                                <div className="contact_tab_item">
                                    <button type="button"
                                        className={`contact_tab_btn fixed_width ${subscriptionViewState === 'History' ? 'active' : ''} p-ripple`}
                                        onClick={() => (handleSwitchSubscriptionViewState('History'))}>
                                        History
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div className="page_main_content_section p-1 p-sm-0">
                            {subscriptionViewState === 'My plan' ? (
                                <React.Fragment>
                                    {subscriptionPlanData && subscriptionPlanData?.length > 0 ? (
                                        <div className="plan_list_section">
                                            <div className="row plan_list_row">
                                                {subscriptionPlanData?.map((subscription) => (
                                                    <React.Fragment>
                                                        <Tooltip
                                                            key={`plan_detail_${subscription?.id}`}
                                                            id={`plan_detail_${subscription?.id}`}
                                                            target={`.plan_detail_${subscription?.id}`}
                                                            mouseTrack
                                                            mouseTrackLeft={-5}
                                                        />

                                                        <div className="col-12 col-sm-6 col-xl-4 plan_list_column" key={subscription?.id}>
                                                            <article className={`plan_list_container p-ripple plan_detail_${subscription?.id}`}
                                                                onClick={() => handleViewSubscriptionPlan(subscription)}
                                                                data-pr-tooltip={`Click to view project details`}
                                                                data-pr-position="top"
                                                            >
                                                                <h5>
                                                                    {subscription?.plan_name}
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </h5>
                                                                <p>Total projects:
                                                                    <span>{String(subscription?.ProjectList?.length).padStart(2, '0')}</span>
                                                                </p>
                                                                <Ripple pt={{ root: { style: { background: 'rgba(139, 96, 253, 0.2)' } } }} />
                                                            </article>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <NoDataCreated
                                            message={`No plan(s) found.`}
                                        />
                                    )}
                                </React.Fragment>
                            ) : subscriptionViewState === 'History' ? (
                                <React.Fragment>
                                    {subscriptionHistoryData && subscriptionHistoryData?.length > 0 ? (
                                        <React.Fragment>
                                            <div className="row p-sm-2 pb-sm-0 p-1">
                                                <div className="col-12">
                                                    <div className="note_text_label primary">
                                                        <span>Note:</span>

                                                        <ul className="note_text_content">
                                                            <li>Subscription fees will be charged at the beginning of each period and may take a few days to appear in your account after the billing date.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <DataTable
                                                value={subscriptionHistoryData}
                                                paginator
                                                size="small"
                                                rows={10}
                                                emptyMessage="No records found!"
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                tableStyle={{ minWidth: '50rem' }}
                                                paginatorDropdownAppendTo={'self'}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                className="page_table p-0 p-sm-2"
                                                rowHover
                                                loading={loadingPaymentHistory}
                                                scrollable
                                            >
                                                <Column
                                                    header="No."
                                                    headerClassName="text_purple"
                                                    className="text_bold"
                                                    body={(rowData: SubscriptionHistory, { rowIndex }) => (
                                                        <span>{rowIndex + 1}.</span>
                                                    )}
                                                    style={{ width: '8%' }}>
                                                </Column>

                                                <Column
                                                    header="Plan"
                                                    headerClassName="text_purple title_column"
                                                    field="plan_name"
                                                    body={(rowData: SubscriptionHistory) => (
                                                        <span className="text-capitalize text_bold text_no_wrap">
                                                            {rowData?.plan_name ? rowData?.plan_name : '---'}
                                                        </span>
                                                    )}
                                                    style={{ width: '12%' }}>
                                                </Column>

                                                <Column
                                                    header="Payment date"
                                                    headerClassName="text_purple"
                                                    field="payment_date"
                                                    body={(rowData: SubscriptionHistory) => (
                                                        <span className="text_no_wrap">
                                                            {rowData?.payment_date ? rowData?.payment_date : '---'}
                                                        </span>
                                                    )}
                                                    style={{ width: '15%' }}>
                                                </Column>

                                                <Column
                                                    header="Subscription date"
                                                    headerClassName="text_purple"
                                                    field="payment_date"
                                                    body={(rowData: SubscriptionHistory) => (
                                                        <span className="text_no_wrap">
                                                            {(rowData?.start_date && rowData?.end_date) ? rowData?.start_date + '  -  ' + rowData?.end_date : '---'}
                                                        </span>
                                                    )}
                                                    style={{ width: '20%' }}>
                                                </Column>

                                                <Column
                                                    header="Amount"
                                                    headerClassName="text_purple"
                                                    alignHeader={'right'}
                                                    field="amount"
                                                    className="text_bold"
                                                    body={(rowData: SubscriptionHistory) => (
                                                        <span className={`text_no_wrap flex_end`}>
                                                            {currencySymbol}&nbsp;{rowData?.total ? (rowData?.total).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                        </span>
                                                    )}
                                                    style={{ width: '15%' }}>
                                                </Column>

                                                <Column
                                                    header="Invoice"
                                                    alignHeader={'center'}
                                                    headerClassName="text_purple"
                                                    body={invoiceViewBody}
                                                    style={{ width: '10%' }}>
                                                </Column>

                                                <Column
                                                    header="Status"
                                                    alignHeader={'center'}
                                                    headerClassName="text_purple"
                                                    body={statusBodyTemplate}
                                                    style={{ width: '10%' }}>
                                                </Column>

                                                <Column
                                                    alignHeader="center"
                                                    body={tableActionBody}
                                                    frozen
                                                    alignFrozen="right"
                                                ></Column>
                                            </DataTable>
                                        </React.Fragment>
                                    ) : (
                                        <NoDataCreated
                                            message={`No record(s) found.`}
                                        />
                                    )}
                                </React.Fragment>
                            ) : null}
                        </div>
                    </div>
                )}
            </div>


            {/* Subscription plan view modal */}
            <Dialog
                visible={showSubscriptionPlanViewModal}
                headerClassName="custom_modal_header"
                header={subscriptionPlanModalHeader}
                dismissableMask
                closeOnEscape={false}
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseSubscriptionPlanViewModal}>
                <div className="custom_modal_body">
                    <div className="p-1">
                        {selectedSubscriptionPlan && selectedSubscriptionPlan !== null ? (
                            <React.Fragment>
                                {selectedSubscriptionPlan?.ProjectList && selectedSubscriptionPlan?.ProjectList?.length > 0 ? (
                                    <div className="row">
                                        <div className="col-12">
                                            <h4 className="view_data_head">
                                                <i className="bi bi-layers me-2"></i>
                                                Projects
                                            </h4>

                                            {selectedSubscriptionPlan?.ProjectList?.map((project, index) => (
                                                <article key={index} className={`data_view_area ${index === selectedSubscriptionPlan?.ProjectList?.length! - 1 ? 'mb-0' : 'mb-2'}`}>
                                                    <div className="view_data_group">
                                                        <div className="row">
                                                            <div className="col-6 col-sm-5">
                                                                <h5 className="view_data_title">Project :</h5>
                                                            </div>
                                                            <div className="col-6 col-sm-7">
                                                                <h5 className="view_data_content text_purple text-capitalize text_bold">
                                                                    {(project?.job_number && project?.address) ? (project?.job_number + ': ' + project?.address) : '----'}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="view_data_group">
                                                        <div className="row">
                                                            <div className="col-6 col-sm-5">
                                                                <h5 className="view_data_title">License activation date :</h5>
                                                            </div>
                                                            <div className="col-6 col-sm-7">
                                                                <h5 className="view_data_content">
                                                                    {project?.project_start_date ? project?.project_start_date : '----'}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="view_data_group">
                                                        <div className="row">
                                                            <div className="col-6 col-sm-5">
                                                                <h5 className="view_data_title">License expiration date :</h5>
                                                            </div>
                                                            <div className="col-6 col-sm-7">
                                                                <h5 className="view_data_content">
                                                                    {project?.project_end_date ? project?.project_end_date : '----'}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="view_data_group">
                                                        <div className="row">
                                                            <div className="col-6 col-sm-5 my-auto">
                                                                <h5 className="view_data_title">Status :</h5>
                                                            </div>
                                                            <div className="col-6 col-sm-7">
                                                                <h5 className="view_data_content as_label"
                                                                    style={{ color: project?.this_project_active === 1 ? '#05ac05' : '#f60000' }}>
                                                                    <span>
                                                                        <i className={`bi ${project?.this_project_active === 1 ? ' bi-check-circle-fill' : ' bi-exclamation-circle-fill'} me-2`}></i>
                                                                        {project?.this_project_active === 1 ? 'Active' : 'Expired'}
                                                                    </span>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </article>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="no_data_found mt-2 mb-2 d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                                        <h6 className="my-auto">
                                            <i className="bi bi-exclamation-circle me-2"></i>
                                            No project(s) was created with the <span className="text_bold text-capitalize">'{selectedSubscriptionPlan?.plan_name}'</span> plan
                                        </h6>
                                    </div>
                                )}
                            </React.Fragment>
                        ) : (
                            <div className="no_data_found mt-2 mb-2">
                                <h6>
                                    <i className="bi bi-exclamation-circle me-2"></i>
                                    No detail found!
                                </h6>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Subscription history view modal */}
            <Dialog
                visible={showSubscriptionHistoryViewModal}
                headerClassName="custom_modal_header"
                header={subscriptionHistoryModalHeader}
                dismissableMask
                closeOnEscape={false}
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseSubscriptionHistoryViewModal}>
                <div className="custom_modal_body">
                    <div className="p-1">
                        {selectedSubscriptionHistory && selectedSubscriptionHistory !== null ? (
                            <div className="row">
                                {/* Subscription details */}
                                <div className="col-12 mb-4">
                                    <h4 className="view_data_head">
                                        <i className="bi bi-calendar-check me-2"></i>
                                        Subscription detail
                                    </h4>

                                    <article className="data_view_area">
                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Plan :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {selectedSubscriptionHistory?.plan_name ? selectedSubscriptionHistory?.plan_name : '----'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Start date :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {selectedSubscriptionHistory?.start_date ? selectedSubscriptionHistory?.start_date : '----'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">End date :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {selectedSubscriptionHistory?.end_date ? selectedSubscriptionHistory?.end_date : '----'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Status :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content as_label"
                                                        style={{ color: selectedSubscriptionHistory?.status === 'Active' ? '#05ac05' : '#7f7f7f' }}>
                                                        <span>
                                                            <i className={`bi ${selectedSubscriptionHistory?.status === 'Active' ? ' bi-check-circle-fill' : ' bi-exclamation-circle-fill'} me-2`}></i>
                                                            {selectedSubscriptionHistory?.status === 'Active' ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                </div>

                                {/* Payment details */}
                                <div className="col-12">
                                    <h4 className="view_data_head">
                                        <i className="bi bi-credit-card me-2"></i>
                                        Payment detail
                                    </h4>

                                    <article className="data_view_area">
                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Payment date :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {selectedSubscriptionHistory?.payment_date ? selectedSubscriptionHistory?.payment_date : '----'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Amount :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {currencySymbol}&nbsp;{selectedSubscriptionHistory?.sub_total ? (selectedSubscriptionHistory?.sub_total).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Tax :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {currencySymbol}&nbsp;{selectedSubscriptionHistory?.tax ? (selectedSubscriptionHistory?.tax).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Discount :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {currencySymbol}&nbsp;{selectedSubscriptionHistory?.discount ? (selectedSubscriptionHistory?.discount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="view_data_group">
                                            <div className="row">
                                                <div className="col-6 col-sm-5">
                                                    <h5 className="view_data_title">Total :</h5>
                                                </div>
                                                <div className="col-6 col-sm-7">
                                                    <h5 className="view_data_content">
                                                        {currencySymbol}&nbsp;{selectedSubscriptionHistory?.total ? (selectedSubscriptionHistory?.total).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        {selectedSubscriptionHistory?.type !== null && (
                                            <div className="view_data_group">
                                                <Tooltip
                                                    key={`payment_type`}
                                                    id={`payment_type`}
                                                    target={`.payment_type`}
                                                />
                                                <div className="row">
                                                    <div className="col-6 col-sm-5">
                                                        <h5 className="view_data_title">Payed with :</h5>
                                                    </div>
                                                    <div className="col-6 col-sm-7">
                                                        <h5 className="view_data_content">
                                                            {selectedSubscriptionHistory?.logo !== null ? (
                                                                <img
                                                                    className="payment_type"
                                                                    src={selectedSubscriptionHistory?.logo}
                                                                    alt={selectedSubscriptionHistory?.type}
                                                                    data-pr-tooltip={selectedSubscriptionHistory?.type}
                                                                    data-pr-position="top"
                                                                />
                                                            ) : (
                                                                selectedSubscriptionHistory?.type ? selectedSubscriptionHistory?.type : '----'
                                                            )}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </article>
                                </div>
                            </div>
                        ) : (
                            <div className="no_data_found mt-2 mb-2">
                                <h6>No detail found!</h6>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Invoice view modal */}
            <DocumentViewModal
                isOpen={showInvoiceViewModal}
                onClose={handleCloseInvoiceViewModal}
                fileUrl={invoiceURL!}
            />
            {/*  */}
        </React.Fragment>
    )
}

export default MySubscription;